import IndividualStats from "./IndividualStats";

export default IndividualStats;
